// extracted by mini-css-extract-plugin
export default {"stakeInput":"SetStakeInput_stakeInput__m32mf"};